import React, { useEffect, useState } from "react";
import Typewriter from "typewriter-effect";

const TYPEWRITER_STRINGS = [
  "Applied AI Engineer",
  "Engineering Leader",
  "Full-Stack Builder",
];

function Type() {
  const [reduceMotion, setReduceMotion] = useState(false);

  useEffect(() => {
    if (!window.matchMedia) {
      return undefined;
    }

    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (!mediaQuery) {
      return undefined;
    }

    setReduceMotion(mediaQuery.matches);

    const handleChange = (event) => setReduceMotion(event.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  if (reduceMotion) {
    return <span className="Typewriter__wrapper">Applied AI Engineer</span>;
  }

  return (
    <Typewriter
      options={{
        strings: TYPEWRITER_STRINGS,
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
